import { createContext, useState, useMemo, useContext, useEffect } from 'react';
import { getTheme } from './theme';
import { ThemeProvider, CssBaseline } from '@mui/material';
import ThemeCssVars from './ThemeCssVars';

// Shape: { mode: 'light' | 'dark', toggleMode: () => void }
const ColorModeContext = createContext({
  mode: 'light',
  toggleMode: () => {},
});

export const useColorMode = () => useContext(ColorModeContext);

const getSavedTheme = () => {
  try {
    const savedTheme = localStorage.getItem('theme');
    return savedTheme === 'dark' || savedTheme === 'light' ? savedTheme : 'light';
  } catch (error) {
    console.error('Failed to load theme from localStorage:', error);
    return 'light';
  }
};

export function ColorModeProvider({ children }) {
  const [mode, setMode] = useState(getSavedTheme);
  
  useEffect(() => {
    try {
      localStorage.setItem('theme', mode);
    } catch (error) {
      console.error('Failed to save theme to localStorage:', error);
    }
  }, [mode]);

  const colorMode = useMemo(() => ({
    mode,
    toggleMode: () => setMode(prev => (prev === 'light' ? 'dark' : 'light')),
  }), [mode]);

  const theme = useMemo(() => getTheme(mode), [mode]);

  return (
    <ColorModeContext.Provider value={colorMode}>
      <ThemeProvider theme={theme}>
        <CssBaseline />
        <ThemeCssVars />
        {children}
      </ThemeProvider>
    </ColorModeContext.Provider>
  );
}
